import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"
import _imports_0 from './assets/video/background.mp4'
import _imports_1 from './assets/video/full.mp4'


const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "app__top",
  id: "app__top"
}
const _hoisted_6 = { class: "app__top-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "app__video",
  width: "100%",
  height: "100%",
  loop: "true",
  autoplay: "",
  muted: ""
}
const _hoisted_8 = { class: "app__wrapper-outer" }
const _hoisted_9 = { class: "app__wrapper" }
const _hoisted_10 = { class: "app__wrapper-flex" }
const _hoisted_11 = { class: "app__video-button" }
const _hoisted_12 = { role: "main" }
const _hoisted_13 = {
  class: "app__section app__section--product",
  id: "section--1"
}
const _hoisted_14 = { class: "app__section app__section--slider" }
const _hoisted_15 = { class: "app__slider" }
const _hoisted_16 = { class: "app__slider visible--block--middle" }
const _hoisted_17 = { class: "app__section app__section--color app__section--color1" }
const _hoisted_18 = {
  class: "app__section app__section--possibilities",
  id: "section--2"
}
const _hoisted_19 = { class: "visible--block--desktops" }
const _hoisted_20 = { class: "app__grid app__grid--1" }
const _hoisted_21 = { class: "app__card" }
const _hoisted_22 = { class: "app__card" }
const _hoisted_23 = { class: "app__card" }
const _hoisted_24 = { class: "app__card" }
const _hoisted_25 = { class: "app__grid app__grid--2" }
const _hoisted_26 = { class: "app__card" }
const _hoisted_27 = { class: "app__card" }
const _hoisted_28 = { class: "app__card" }
const _hoisted_29 = { class: "visible--block--middle" }
const _hoisted_30 = { class: "app__grid app__grid--1" }
const _hoisted_31 = { class: "app__card" }
const _hoisted_32 = { class: "app__card" }
const _hoisted_33 = { class: "app__grid--3" }
const _hoisted_34 = { class: "app__card" }
const _hoisted_35 = { class: "app__grid app__grid--2" }
const _hoisted_36 = { class: "app__card" }
const _hoisted_37 = { class: "app__card" }
const _hoisted_38 = { class: "app__card" }
const _hoisted_39 = { class: "app__card" }
const _hoisted_40 = { class: "visible--block--narrow" }
const _hoisted_41 = { class: "app__grid app__grid--1" }
const _hoisted_42 = { class: "app__card" }
const _hoisted_43 = { class: "app__card" }
const _hoisted_44 = { class: "app__card" }
const _hoisted_45 = { class: "app__grid app__grid--2" }
const _hoisted_46 = { class: "app__card" }
const _hoisted_47 = { class: "app__card" }
const _hoisted_48 = { class: "app__card" }
const _hoisted_49 = { class: "app__card" }
const _hoisted_50 = { class: "app__section app__section--national" }
const _hoisted_51 = { class: "app__grid app__grid--2" }
const _hoisted_52 = { class: "app__card3" }
const _hoisted_53 = { class: "app__card-header app__card-header--info" }
const _hoisted_54 = {
  key: 0,
  class: "app__popup"
}
const _hoisted_55 = { class: "app__card3" }
const _hoisted_56 = { class: "app__card3" }
const _hoisted_57 = {
  class: "app__section app__section--clients",
  id: "section--3"
}
const _hoisted_58 = { class: "app__grid" }
const _hoisted_59 = { class: "app__card3" }
const _hoisted_60 = { class: "app__card3" }
const _hoisted_61 = { class: "app__card3" }
const _hoisted_62 = { class: "app__section app__section--color app__section--color2" }
const _hoisted_63 = {
  class: "app__section app__section--map",
  id: "section--4"
}
const _hoisted_64 = { class: "app__not-map" }
const _hoisted_65 = { class: "app__section app__section--individual" }
const _hoisted_66 = {
  class: "app__section app__section--support",
  id: "section--5"
}
const _hoisted_67 = { class: "app__section-header" }
const _hoisted_68 = { class: "app__section app__section--news" }
const _hoisted_69 = { class: "app__grid hidden--grid--narrow" }
const _hoisted_70 = { class: "app__newses" }
const _hoisted_71 = { class: "app__news-info" }
const _hoisted_72 = { class: "app__news-date" }
const _hoisted_73 = { class: "app__news-version" }
const _hoisted_74 = { class: "app__news-text" }
const _hoisted_75 = { class: "app__grid visible--block--narrow" }
const _hoisted_76 = { class: "app__newses" }
const _hoisted_77 = { class: "app__news-info" }
const _hoisted_78 = { class: "app__news-date" }
const _hoisted_79 = { class: "app__news-version" }
const _hoisted_80 = { class: "app__news-text" }
const _hoisted_81 = { class: "app__modal-video" }
const _hoisted_82 = ["width", "height"]
const _hoisted_83 = { class: "app__modal-video-wrapper" }
const _hoisted_84 = { class: "app__modal-form" }
const _hoisted_85 = { class: "app__form-grid" }
const _hoisted_86 = { class: "app__modal-check" }
const _hoisted_87 = { class: "app__button" }
const _hoisted_88 = {
  key: 0,
  class: "app__plank-wrapper"
}
const _hoisted_89 = { class: "app__plank visible--flex--not-narrow" }
const _hoisted_90 = { class: "app__plank-text" }
const _hoisted_91 = { class: "app__plank visible--block--narrow" }
const _hoisted_92 = { class: "app__plank-text" }
const _hoisted_93 = { class: "app__plank-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Plank = _resolveComponent("Plank")!
  const _component_Wrapper = _resolveComponent("Wrapper")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ButtonAction = _resolveComponent("ButtonAction")!
  const _component_ButtonPlayer = _resolveComponent("ButtonPlayer")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_LayoutSite = _resolveComponent("LayoutSite")!
  const _component_ButtonSimple = _resolveComponent("ButtonSimple")!
  const _component_DS = _resolveComponent("DS")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_DS, null, {
    default: _withCtx(() => [
      _createVNode(_component_LayoutSite, { items: [
        { link: '#section--1', text: 'Модули' },
        { link: '#section--2', text: 'Возможности' },
        { link: '#section--3', text: 'Для кого' },
        { link: '#section--4', text: 'Внедрения' },
        { link: '#section--5', text: 'Поддержка' },
      ] }, {
        logo: _withCtx(() => [
          (_ctx.theme === _ctx.Themes.default && _ctx.isScroll)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require(`@/assets/svg/logo_main.svg`)
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require(`@/assets/svg/logo_main--white.svg`)
              }, null, 8, _hoisted_2))
        ]),
        "logo-gadgets": _withCtx(() => [
          (_ctx.theme === _ctx.Themes.default)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require(`@/assets/svg/logo_main.svg`)
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require(`@/assets/svg/logo_main--white.svg`)
              }, null, 8, _hoisted_4))
        ]),
        button: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "layout__button",
            size: "polyxo",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setModal('form')), ["prevent"]))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("Заявка на подключение")
            ])),
            _: 1
          })
        ]),
        "button-gadgets": _withCtx(() => [
          _createVNode(_component_Button, {
            class: "layout__gadgets-menu-button",
            size: "helike",
            "is-wide": "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setModal('form')), ["prevent"]))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("Заявка на подключение")
            ])),
            _: 1
          })
        ]),
        landing: _withCtx(() => [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.isMounted)
                ? (_openBlock(), _createElementBlock("video", _hoisted_7, _cache[15] || (_cache[15] = [
                    _createElementVNode("source", {
                      src: _imports_0,
                      type: "video/mp4"
                    }, null, -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "app__top-overlay" }, null, -1)),
            _createVNode(_component_Wrapper, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "app__title" }, "Цифровое ресурсоснабжение", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "app__text" }, [
                      _createTextVNode(" платформа для автоматизации основных бизнес-процессов"),
                      _createElementVNode("br", { class: "hidden--inline--gadgets" }),
                      _createElementVNode("span", { class: "hidden--inline--desktops" }, " "),
                      _createTextVNode("ресурсоснабжающих предприятий и создания единого"),
                      _createElementVNode("br", { class: "hidden--inline--gadgets" }),
                      _createElementVNode("span", { class: "hidden--inline--desktops" }, " "),
                      _createTextVNode("информационного пространства ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Button, {
                        size: "laripha",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setModal('form')), ["prevent"]))
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("Заказать демонстрацию")
                        ])),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_Plank, {
                          title: "Видеопрезентация",
                          subtitle: "5:28, 140 Мб",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setModal('video')), ["prevent"]))
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        modals: _withCtx(() => [
          _withDirectives(_createVNode(_component_Modal, { "is-viewport": "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("video", {
                  id: "app__video",
                  class: "app__modal-video",
                  width: _ctx.width2,
                  height: _ctx.height2
                }, _cache[127] || (_cache[127] = [
                  _createElementVNode("source", {
                    src: _imports_1,
                    type: "video/mp4"
                  }, null, -1)
                ]), 8, _hoisted_82),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_Button, {
                    class: "app__modal-video-close",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"])),
                    "is-icon": ""
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_Icon, { name: "close_16" })
                    ]),
                    default: _withCtx(() => [
                      _cache[128] || (_cache[128] = _createElementVNode("span", null, "Закрыть", -1))
                    ]),
                    _: 1
                  }),
                  (!_ctx.isPlay)
                    ? (_openBlock(), _createBlock(_component_ButtonPlayer, {
                        key: 0,
                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.play()), ["prevent"]))
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.modal === 'video']
          ]),
          _withDirectives(_createVNode(_component_Modal, null, {
            default: _withCtx(() => [
              _cache[130] || (_cache[130] = _createElementVNode("div", { class: "app__modal-title" }, " Закажите бесплатную демонстрацию продукта ", -1)),
              _cache[131] || (_cache[131] = _createElementVNode("div", { class: "app__modal-subtitle" }, " Наш менеджер свяжется с Вами, чтобы обсудить детали и договориться об удобном времени ", -1)),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.nickname,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nickname) = $event)),
                      placeholder: "Как к Вам обращаться"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.phone,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phone) = $event)),
                      placeholder: "Номер телефона",
                      "is-phone": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(_component_Checkbox, {
                    text: "Я предоставляю ",
                    text2: " и соглашаюсь с условиями ",
                    modelValue: _ctx.isCheckModal,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isCheckModal) = $event))
                  }, {
                    link: _withCtx(() => [
                      _createVNode(_component_Link, {
                        text: "Согласие на обработку персональных данных",
                        link: `./Consent_of_Personal_Data_processing.pdf`
                      })
                    ]),
                    link2: _withCtx(() => [
                      _createVNode(_component_Link, {
                        text: "Политики в отношении обработки персональных данных",
                        link: `./Personal_Data_Processing_Policy.pdf`
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_Button, {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.postForm()), ["prevent"])),
                    size: "helike",
                    "is-wide": "",
                    "is-disabled": !_ctx.isCheckModal
                  }, {
                    default: _withCtx(() => _cache[129] || (_cache[129] = [
                      _createTextVNode("Отправить")
                    ])),
                    _: 1
                  }, 8, ["is-disabled"])
                ])
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.modal === 'form']
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Footer)
        ]),
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_12, [
            _createElementVNode("section", _hoisted_13, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("div", { class: "app__title" }, "О продукте", -1),
                  _createElementVNode("div", { class: "app__subtitle" }, " 6 модулей для производства, эксплуатации, сбыта и управления ресурсоснабжением ", -1),
                  _createElementVNode("div", { class: "app__grid" }, [
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Производство"),
                      _createElementVNode("div", { class: "app__card-header" }, "Анализ режимов"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для мониторинга и анализа режимов работы оборудования, отдельных сегментов сети, повышения качества и надёжности ")
                    ]),
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Производство"),
                      _createElementVNode("div", { class: "app__card-header" }, "Анализ балансов"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для выявления зон наибольших потерь и локализации дисбаланса системы, сокращения коммерческих и технологических потерь ")
                    ]),
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Эксплуатация"),
                      _createElementVNode("div", { class: "app__card-header" }, "Поддержка эксплуатации"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для повышения эффективности работы эксплуатационного персонала на объектах предприятия ")
                    ]),
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Эксплуатация"),
                      _createElementVNode("div", { class: "app__card-header" }, "Заявки"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для повышения эффективности выполнения плановых и аварийных ремонтных работ, использования транспортных средств и спецтехники ")
                    ]),
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Сбыт"),
                      _createElementVNode("div", { class: "app__card-header" }, "Обходчик контролёр"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для автоматизации обследования абонентов, контроля потребления ресурсов ")
                    ]),
                    _createElementVNode("div", { class: "app__card" }, [
                      _createElementVNode("div", { class: "app__card-tag" }, "Управление"),
                      _createElementVNode("div", { class: "app__card-header" }, "Центральная панель"),
                      _createElementVNode("div", { class: "app__card-text" }, " Модуль для умного визуального представления ключевых показателей через систему гибко настраиваемых панелей индикаторов ")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_14, [
              _createVNode(_component_Wrapper, { class: "hidden--block--middle" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(), _createBlock(_component_Carousel, _mergeProps(_ctx.screenshotsCarouselConfig, { key: _ctx.slider }), {
                      addons: _withCtx(() => [
                        _createVNode(_component_Navigation, null, {
                          prev: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("div", { class: "app__arrow-left" }, [
                              _createElementVNode("svg", {
                                class: "visible--block--narrow",
                                width: "32",
                                height: "32",
                                viewBox: "0 0 32 32",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("rect", {
                                  width: "32",
                                  height: "32",
                                  rx: "16",
                                  fill: "white"
                                }),
                                _createElementVNode("path", {
                                  d: "M18.8378 10.0416C19.1368 9.57729 19.0028 8.95846 18.5385 8.65941C18.3708 8.55135 18.1828 8.49983 17.9971 8.5C17.6688 8.5003 17.3473 8.66209 17.1563 8.95864L13.6673 14.3757C13.6656 14.3783 13.6639 14.3809 13.6623 14.3835L13.3186 14.9172C12.8938 15.5767 12.8938 16.4236 13.3186 17.0831L13.6623 17.6168C13.664 17.6194 13.6656 17.622 13.6673 17.6246L17.1563 23.0416C17.2685 23.2157 17.4256 23.3434 17.6027 23.4192C17.8524 23.5261 18.1417 23.5298 18.4007 23.4152C18.4478 23.3944 18.4939 23.3696 18.5385 23.3408C19.0029 23.0418 19.1368 22.4229 18.8378 21.9586L15.3487 16.5416C15.3478 16.5401 15.3468 16.5386 15.3458 16.5371C15.1373 16.2095 15.1373 15.7908 15.3458 15.4632L18.8378 10.0416Z",
                                  fill: "#80858E"
                                })
                              ]),
                              _createElementVNode("svg", {
                                class: "hidden--block--narrow",
                                width: "48",
                                height: "48",
                                viewBox: "0 0 48 48",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("rect", {
                                  width: "48",
                                  height: "48",
                                  rx: "24",
                                  fill: "white"
                                }),
                                _createElementVNode("path", {
                                  d: "M29.8255 9.56267C30.1362 9.10607 30.018 8.48405 29.5614 8.17335C29.3892 8.05617 29.1934 8.00001 28.9997 8C28.6797 7.9998 28.3651 8.15296 28.1715 8.43753L18.7302 22.3124C18.7202 22.3271 18.7103 22.3419 18.7005 22.3568L18.348 22.875C17.886 23.5539 17.886 24.4463 18.348 25.1252L18.7006 25.6434C18.7103 25.6583 18.7202 25.6731 18.7302 25.6878L28.1715 39.5627C28.3651 39.8472 28.6797 40.0004 28.9997 40.0002C29.1934 40.0002 29.3892 39.944 29.5614 39.8268C30.018 39.5161 30.1362 38.8941 29.8255 38.4375L20.3667 24.5369C20.1583 24.2095 20.1584 23.7907 20.3668 23.4633L29.8255 9.56267Z",
                                  fill: "#80858E"
                                })
                              ])
                            ], -1)
                          ])),
                          next: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("div", { class: "app__arrow-right" }, [
                              _createElementVNode("svg", {
                                class: "visible--block--narrow",
                                width: "32",
                                height: "32",
                                viewBox: "0 0 32 32",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("rect", {
                                  width: "32",
                                  height: "32",
                                  rx: "16",
                                  fill: "white"
                                }),
                                _createElementVNode("g", { "clip-path": "url(#clip0_926_2355)" }, [
                                  _createElementVNode("path", {
                                    d: "M13.1623 10.0416C12.8633 9.57729 12.9973 8.95846 13.4616 8.65941C13.6293 8.55135 13.8173 8.49983 14.003 8.5C14.3313 8.5003 14.6528 8.66209 14.8438 8.95864L18.3328 14.3757C18.3345 14.3783 18.3362 14.3809 18.3378 14.3835L18.6815 14.9172C19.1063 15.5767 19.1063 16.4236 18.6815 17.0831L18.3378 17.6168C18.3361 17.6194 18.3345 17.622 18.3328 17.6246L14.8438 23.0416C14.7316 23.2157 14.5745 23.3434 14.3974 23.4192C14.1477 23.5261 13.8584 23.5298 13.5994 23.4152C13.5523 23.3944 13.5062 23.3696 13.4616 23.3408C12.9973 23.0418 12.8633 22.4229 13.1623 21.9586L16.6514 16.5416C16.6523 16.5401 16.6533 16.5386 16.6543 16.5371C16.8628 16.2095 16.8628 15.7908 16.6543 15.4632L13.1623 10.0416Z",
                                    fill: "#80858E"
                                  })
                                ]),
                                _createElementVNode("defs", null, [
                                  _createElementVNode("clipPath", { id: "clip0_926_2355" }, [
                                    _createElementVNode("rect", {
                                      width: "6",
                                      height: "16",
                                      fill: "white",
                                      transform: "translate(13 8)"
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("svg", {
                                class: "hidden--block--narrow",
                                width: "48",
                                height: "48",
                                viewBox: "0 0 48 48",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("rect", {
                                  width: "48",
                                  height: "48",
                                  rx: "24",
                                  fill: "white"
                                }),
                                _createElementVNode("path", {
                                  d: "M18.1748 9.56267C17.8641 9.10607 17.9824 8.48405 18.439 8.17335C18.6112 8.05617 18.8069 8.00001 19.0006 8C19.3207 7.9998 19.6352 8.15296 19.8289 8.43753L29.2702 22.3124C29.2802 22.3271 29.2901 22.3419 29.2998 22.3568L29.6524 22.875C30.1144 23.5539 30.1144 24.4463 29.6524 25.1252L29.2998 25.6434C29.2901 25.6583 29.2802 25.6731 29.2702 25.6878L19.8289 39.5627C19.6352 39.8472 19.3207 40.0004 19.0006 40.0002C18.8069 40.0002 18.6112 39.944 18.439 39.8268C17.9824 39.5161 17.8641 38.8941 18.1748 38.4375L27.6336 24.5369C27.842 24.2095 27.842 23.7907 27.6336 23.4633L18.1748 9.56267Z",
                                  fill: "#80858E"
                                })
                              ])
                            ], -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_Pagination)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (slide) => {
                          return _createVNode(_component_Slide, { key: slide }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(`app__slide app__slide--${slide}`)
                              }, null, 2)
                            ]),
                            _: 2
                          }, 1024)
                        }), 64))
                      ]),
                      _: 1
                    }, 16))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createBlock(_component_Carousel, _mergeProps(_ctx.screenshotsCarouselConfig, { key: _ctx.slider }), {
                  addons: _withCtx(() => [
                    _createVNode(_component_Navigation, null, {
                      prev: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createElementVNode("div", { class: "app__arrow-left" }, [
                          _createElementVNode("svg", {
                            class: "visible--block--narrow",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("rect", {
                              width: "32",
                              height: "32",
                              rx: "16",
                              fill: "white"
                            }),
                            _createElementVNode("path", {
                              d: "M18.8378 10.0416C19.1368 9.57729 19.0028 8.95846 18.5385 8.65941C18.3708 8.55135 18.1828 8.49983 17.9971 8.5C17.6688 8.5003 17.3473 8.66209 17.1563 8.95864L13.6673 14.3757C13.6656 14.3783 13.6639 14.3809 13.6623 14.3835L13.3186 14.9172C12.8938 15.5767 12.8938 16.4236 13.3186 17.0831L13.6623 17.6168C13.664 17.6194 13.6656 17.622 13.6673 17.6246L17.1563 23.0416C17.2685 23.2157 17.4256 23.3434 17.6027 23.4192C17.8524 23.5261 18.1417 23.5298 18.4007 23.4152C18.4478 23.3944 18.4939 23.3696 18.5385 23.3408C19.0029 23.0418 19.1368 22.4229 18.8378 21.9586L15.3487 16.5416C15.3478 16.5401 15.3468 16.5386 15.3458 16.5371C15.1373 16.2095 15.1373 15.7908 15.3458 15.4632L18.8378 10.0416Z",
                              fill: "#80858E"
                            })
                          ]),
                          _createElementVNode("svg", {
                            class: "hidden--block--narrow",
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("rect", {
                              width: "48",
                              height: "48",
                              rx: "24",
                              fill: "white"
                            }),
                            _createElementVNode("path", {
                              d: "M29.8255 9.56267C30.1362 9.10607 30.018 8.48405 29.5614 8.17335C29.3892 8.05617 29.1934 8.00001 28.9997 8C28.6797 7.9998 28.3651 8.15296 28.1715 8.43753L18.7302 22.3124C18.7202 22.3271 18.7103 22.3419 18.7005 22.3568L18.348 22.875C17.886 23.5539 17.886 24.4463 18.348 25.1252L18.7006 25.6434C18.7103 25.6583 18.7202 25.6731 18.7302 25.6878L28.1715 39.5627C28.3651 39.8472 28.6797 40.0004 28.9997 40.0002C29.1934 40.0002 29.3892 39.944 29.5614 39.8268C30.018 39.5161 30.1362 38.8941 29.8255 38.4375L20.3667 24.5369C20.1583 24.2095 20.1584 23.7907 20.3668 23.4633L29.8255 9.56267Z",
                              fill: "#80858E"
                            })
                          ])
                        ], -1)
                      ])),
                      next: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createElementVNode("div", { class: "app__arrow-right" }, [
                          _createElementVNode("svg", {
                            class: "visible--block--narrow",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("rect", {
                              width: "32",
                              height: "32",
                              rx: "16",
                              fill: "white"
                            }),
                            _createElementVNode("g", { "clip-path": "url(#clip0_926_2355)" }, [
                              _createElementVNode("path", {
                                d: "M13.1623 10.0416C12.8633 9.57729 12.9973 8.95846 13.4616 8.65941C13.6293 8.55135 13.8173 8.49983 14.003 8.5C14.3313 8.5003 14.6528 8.66209 14.8438 8.95864L18.3328 14.3757C18.3345 14.3783 18.3362 14.3809 18.3378 14.3835L18.6815 14.9172C19.1063 15.5767 19.1063 16.4236 18.6815 17.0831L18.3378 17.6168C18.3361 17.6194 18.3345 17.622 18.3328 17.6246L14.8438 23.0416C14.7316 23.2157 14.5745 23.3434 14.3974 23.4192C14.1477 23.5261 13.8584 23.5298 13.5994 23.4152C13.5523 23.3944 13.5062 23.3696 13.4616 23.3408C12.9973 23.0418 12.8633 22.4229 13.1623 21.9586L16.6514 16.5416C16.6523 16.5401 16.6533 16.5386 16.6543 16.5371C16.8628 16.2095 16.8628 15.7908 16.6543 15.4632L13.1623 10.0416Z",
                                fill: "#80858E"
                              })
                            ]),
                            _createElementVNode("defs", null, [
                              _createElementVNode("clipPath", { id: "clip0_926_2355" }, [
                                _createElementVNode("rect", {
                                  width: "6",
                                  height: "16",
                                  fill: "white",
                                  transform: "translate(13 8)"
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("svg", {
                            class: "hidden--block--narrow",
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("rect", {
                              width: "48",
                              height: "48",
                              rx: "24",
                              fill: "white"
                            }),
                            _createElementVNode("path", {
                              d: "M18.1748 9.56267C17.8641 9.10607 17.9824 8.48405 18.439 8.17335C18.6112 8.05617 18.8069 8.00001 19.0006 8C19.3207 7.9998 19.6352 8.15296 19.8289 8.43753L29.2702 22.3124C29.2802 22.3271 29.2901 22.3419 29.2998 22.3568L29.6524 22.875C30.1144 23.5539 30.1144 24.4463 29.6524 25.1252L29.2998 25.6434C29.2901 25.6583 29.2802 25.6731 29.2702 25.6878L19.8289 39.5627C19.6352 39.8472 19.3207 40.0004 19.0006 40.0002C18.8069 40.0002 18.6112 39.944 18.439 39.8268C17.9824 39.5161 17.8641 38.8941 18.1748 38.4375L27.6336 24.5369C27.842 24.2095 27.842 23.7907 27.6336 23.4633L18.1748 9.56267Z",
                              fill: "#80858E"
                            })
                          ])
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Pagination)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (slide) => {
                      return _createVNode(_component_Slide, { key: slide }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(`app__slide app__slide--${slide}`)
                          }, null, 2)
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                }, 16))
              ])
            ]),
            _createElementVNode("section", _hoisted_17, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("div", { class: "app__color app__color--1" }, [
                    _createElementVNode("div", { class: "app__color-wrapper-outer visible--flex--widest" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--1" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Управление ресурсами"),
                              _createElementVNode("br"),
                              _createTextVNode("на основе «больших данных» ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--2" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Математическое моделирование"),
                              _createElementVNode("br"),
                              _createTextVNode("и машинное обучение ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--3" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Мобильные"),
                              _createElementVNode("br"),
                              _createTextVNode("технологии")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--4" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Аналитика и роботизация оцифрованных"),
                              _createElementVNode("br"),
                              _createTextVNode("бизнес-процессов предприятия ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--5" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Цифровой контроль за выполнением"),
                              _createElementVNode("br"),
                              _createTextVNode("измеримых показателей ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__color-wrapper-outer visible--flex--wide" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--1" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Управление ресурсами"),
                              _createElementVNode("br"),
                              _createTextVNode("на основе «больших данных» ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--2" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Математическое моделирование"),
                              _createElementVNode("br"),
                              _createTextVNode("и машинное обучение ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--3" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Мобильные"),
                              _createElementVNode("br"),
                              _createTextVNode("технологии")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--4" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Аналитика и роботизация оцифрованных"),
                              _createElementVNode("br"),
                              _createTextVNode("бизнес-процессов предприятия ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--5" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Цифровой контроль за выполнением"),
                              _createElementVNode("br"),
                              _createTextVNode("измеримых показателей ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__color-wrapper-outer visible--flex--middle" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--1" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Управление ресурсами"),
                              _createElementVNode("br"),
                              _createTextVNode("на основе «больших данных» ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--2" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Математическое моделирование"),
                              _createElementVNode("br"),
                              _createTextVNode("и машинное обучение ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--3" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Мобильные"),
                              _createElementVNode("br"),
                              _createTextVNode("технологии")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--4" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Аналитика и роботизация оцифрованных"),
                              _createElementVNode("br"),
                              _createTextVNode("бизнес-процессов предприятия ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--5" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Цифровой контроль за выполнением"),
                              _createElementVNode("br"),
                              _createTextVNode("измеримых показателей ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__color-wrapper-outer visible--flex--narrow" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--1" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Управление ресурсами"),
                              _createElementVNode("br"),
                              _createTextVNode("на основе «больших данных» ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--2" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Математическое моделирование"),
                              _createElementVNode("br"),
                              _createTextVNode("и машинное обучение ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--3" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Мобильные"),
                              _createElementVNode("br"),
                              _createTextVNode("технологии")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--4" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Аналитика и роботизация"),
                              _createElementVNode("br"),
                              _createTextVNode("оцифрованных бизнес-"),
                              _createElementVNode("br"),
                              _createTextVNode("процессов предприятия ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--5" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Цифровой контроль за выполнением"),
                              _createElementVNode("br"),
                              _createTextVNode("измеримых показателей ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_18, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => [
                  _cache[68] || (_cache[68] = _createElementVNode("div", { class: "app__title" }, "Возможности", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos1"
                        }),
                        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "app__card-header" }, "Обработка данных", -1)),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "app__card-text" }, " технологических параметров работы объектов ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos2"
                        }),
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "app__card-header" }, "Расчёт и мониторинг", -1)),
                        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "app__card-text" }, " эффективности работы оборудования объектов ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos3"
                        }),
                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "app__card-header" }, "Управление", -1)),
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "app__card-text" }, " ремонтными и аварийными работами ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos4"
                        }),
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация работы", -1)),
                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "app__card-text" }, " оперативного персонала на объектах предприятия ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos5"
                        }),
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация процессов", -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "app__card-text" }, " взаимодействия с потребителями и персоналом ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos6"
                        }),
                        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "app__card-header" }, "План-факторный анализ", -1)),
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "app__card-text" }, " объёмов ресурса от источника до потребителя ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos7"
                        }),
                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "app__card-header" }, " Интеллектуальное представление ", -1)),
                        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "app__card-text" }, " ключевых показателей эффективности ", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos1"
                        }),
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "app__card-header" }, "Обработка данных", -1)),
                        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "app__card-text" }, " технологических параметров работы объектов ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos2"
                        }),
                        _cache[42] || (_cache[42] = _createElementVNode("div", { class: "app__card-header" }, "Расчёт и мониторинг", -1)),
                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "app__card-text" }, " эффективности работы оборудования объектов ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos3"
                        }),
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "app__card-header" }, "Управление", -1)),
                        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "app__card-text" }, " ремонтными и аварийными работами ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos4"
                        }),
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация работы", -1)),
                        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "app__card-text" }, " оперативного персонала на объектах предприятия ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos5"
                        }),
                        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация процессов", -1)),
                        _cache[49] || (_cache[49] = _createElementVNode("div", { class: "app__card-text" }, " взаимодействия с потребителями и персоналом ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos6"
                        }),
                        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "app__card-header" }, "План-факторный анализ", -1)),
                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "app__card-text" }, " объёмов ресурса от источника до потребителя ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos7"
                        }),
                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "app__card-header" }, " Интеллектуальное представление ", -1)),
                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "app__card-text" }, " ключевых показателей эффективности ", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos1"
                        }),
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "app__card-header" }, "Обработка данных", -1)),
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "app__card-text" }, " технологических параметров работы объектов ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos2"
                        }),
                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "app__card-header" }, "Расчёт и мониторинг", -1)),
                        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "app__card-text" }, " эффективности работы оборудования объектов ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos3"
                        }),
                        _cache[58] || (_cache[58] = _createElementVNode("div", { class: "app__card-header" }, "Управление", -1)),
                        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "app__card-text" }, " ремонтными и аварийными работами ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos4"
                        }),
                        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация работы", -1)),
                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "app__card-text" }, " оперативного персонала на объектах предприятия ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos5"
                        }),
                        _cache[62] || (_cache[62] = _createElementVNode("div", { class: "app__card-header" }, "Автоматизация процессов", -1)),
                        _cache[63] || (_cache[63] = _createElementVNode("div", { class: "app__card-text" }, " взаимодействия с потребителями и персоналом ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos6"
                        }),
                        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "app__card-header" }, "План-факторный анализ", -1)),
                        _cache[65] || (_cache[65] = _createElementVNode("div", { class: "app__card-text" }, " объёмов ресурса от источника до потребителя ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_Icon, {
                          class: "app__card-icon",
                          name: "pos7"
                        }),
                        _cache[66] || (_cache[66] = _createElementVNode("div", { class: "app__card-header" }, " Интеллектуальное представление ", -1)),
                        _cache[67] || (_cache[67] = _createElementVNode("div", { class: "app__card-text" }, " ключевых показателей эффективности ", -1))
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_50, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => _cache[69] || (_cache[69] = [
                  _createElementVNode("div", { class: "app__title" }, " Соответствует национальным целям и стандартам ", -1),
                  _createElementVNode("div", { class: "app__grid app__grid--1 hidden--grid--narrow" }, [
                    _createElementVNode("div", { class: "app__card2" }, [
                      _createElementVNode("div", { class: "app__card-header2" }, "Указ Президента РФ №166"),
                      _createElementVNode("div", { class: "app__card-text2" }, " Улучшение качества и надежности обеспечения теплом и ГВС населения, снижение потребления энергоресурсов, снижение количества аварий, повышение эффективности и прозрачности процессов теплоснабжения ")
                    ]),
                    _createElementVNode("div", { class: "app__card2" }, [
                      _createElementVNode("div", { class: "app__card-header2" }, "Указ Президента РФ №474"),
                      _createElementVNode("div", { class: "app__card-text2" }, " О национальных целях развития Российской Федерации на период до 2030 года ")
                    ]),
                    _createElementVNode("div", { class: "app__card2" }, [
                      _createElementVNode("div", { class: "app__card-header2" }, "Указ Минстроя РФ №357/пр."),
                      _createElementVNode("div", { class: "app__card-text2" }, " Перечень базовых и дополнительных показателей цифровизации городского хозяйства — Стандарт «Умного города» ")
                    ]),
                    _createElementVNode("div", { class: "app__card2" }, [
                      _createElementVNode("div", { class: "app__card-header2" }, "УГТ 9"),
                      _createElementVNode("div", { class: "app__card-text2" }, " Соответствие ГОСТ Р 58048-2017. Удовлетворяет всем требованиям: инженерным, производственным, эксплуатационным, по качеству и надежности ")
                    ])
                  ], -1)
                ])),
                _: 1
              }),
              (_openBlock(), _createBlock(_component_Carousel, _mergeProps({ class: "app__mobile-slider1 visible--block--narrow" }, _ctx.nationalStandardsCarouselConfig, { key: _ctx.slider }), {
                addons: _withCtx(() => [
                  _createVNode(_component_Navigation, null, {
                    prev: _withCtx(() => _cache[74] || (_cache[74] = [])),
                    next: _withCtx(() => _cache[75] || (_cache[75] = [])),
                    _: 1
                  }),
                  _createVNode(_component_Pagination)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Slide, null, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createElementVNode("div", { class: "app__card2 app__card2--in-slide" }, [
                        _createElementVNode("div", { class: "app__card-header2" }, "Указ Президента РФ №166"),
                        _createElementVNode("div", { class: "app__card-text2" }, " Улучшение качества и надежности обеспечения теплом и ГВС населения, снижение потребления энергоресурсов, снижение количества аварий, повышение эффективности и прозрачности процессов теплоснабжения ")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_Slide, null, {
                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                      _createElementVNode("div", { class: "app__card2 app__card2--in-slide" }, [
                        _createElementVNode("div", { class: "app__card-header2" }, "Указ Президента РФ №474"),
                        _createElementVNode("div", { class: "app__card-text2" }, " О национальных целях развития Российской Федерации на период до 2030 года ")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_Slide, null, {
                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                      _createElementVNode("div", { class: "app__card2 app__card2--in-slide" }, [
                        _createElementVNode("div", { class: "app__card-header2" }, "Указ Минстроя РФ №357/пр."),
                        _createElementVNode("div", { class: "app__card-text2" }, " Перечень базовых и дополнительных показателей цифровизации городского хозяйства — Стандарт «Умного города» ")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_Slide, null, {
                    default: _withCtx(() => _cache[73] || (_cache[73] = [
                      _createElementVNode("div", { class: "app__card2 app__card2--in-slide" }, [
                        _createElementVNode("div", { class: "app__card-header2" }, "УГТ 9"),
                        _createElementVNode("div", { class: "app__card-text2" }, " Соответствие ГОСТ Р 58048-2017. Удовлетворяет всем требованиям: инженерным, производственным, эксплуатационным, по качеству и надежности ")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)),
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "nat1"
                      }),
                      _createElementVNode("div", _hoisted_53, [
                        _cache[77] || (_cache[77] = _createTextVNode(" Сделано в России")),
                        _createElementVNode("a", {
                          href: "",
                          class: "app__card-info",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tryClick && _ctx.tryClick(...args)), ["prevent"]))
                        }, [
                          _createVNode(_component_Icon, { name: "info" })
                        ]),
                        (_ctx.isPopup1)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, _cache[76] || (_cache[76] = [
                              _createTextVNode(" Запись в Российском реестре программного обеспечения №11959 от 29.10.2021 произведена на основании приказа Министерства цифрового развития, связи и массовых коммуникаций Российской Федерации от 28.10.2021 №1105 ")
                            ]))), [
                              [_directive_click_outside, _ctx.onClickOutside]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _cache[78] || (_cache[78] = _createElementVNode("div", { class: "app__card-text" }, " 100% российское решение, зарегистрированное в реестре отечественного ПО ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "nat2"
                      }),
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "app__card-header" }, "Продукт Росатома", -1)),
                      _cache[80] || (_cache[80] = _createElementVNode("div", { class: "app__card-text" }, " Разработано Госкорпорацией — ключевым участником национального проекта «Цифровая экономика» ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "nat3"
                      }),
                      _cache[81] || (_cache[81] = _createElementVNode("div", { class: "app__card-header" }, "Импортозамещение", -1)),
                      _cache[82] || (_cache[82] = _createElementVNode("div", { class: "app__card-text" }, " Продукт выполняет функции подобных программных решений иностранных производителей ", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_57, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => [
                  _cache[92] || (_cache[92] = _createElementVNode("div", { class: "app__title" }, "Наши заказчики", -1)),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "industrial"
                      }),
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "app__card-subheader" }, " ЖКХ (тепло- и водоснабжение) и теплоэнергетика ", -1)),
                      _cache[84] || (_cache[84] = _createElementVNode("div", { class: "app__card-header" }, " Ресурсоснабжающие организации ", -1)),
                      _cache[85] || (_cache[85] = _createElementVNode("ul", { class: "app__card-list" }, [
                        _createElementVNode("li", null, "Повышение качества предоставляемых услуг"),
                        _createElementVNode("li", null, " Повышение эффективности работы технологических объектов "),
                        _createElementVNode("li", null, " Снижение технических и коммерческих потерь поставляемого ресурса ")
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "school"
                      }),
                      _cache[86] || (_cache[86] = _createElementVNode("div", { class: "app__card-subheader" }, " Горячее и холодное водоснабжение, теплоснабжение ", -1)),
                      _cache[87] || (_cache[87] = _createElementVNode("div", { class: "app__card-header" }, "Потребители — население", -1)),
                      _cache[88] || (_cache[88] = _createElementVNode("ul", { class: "app__card-list" }, [
                        _createElementVNode("li", null, " Рост качества услуг, обслуживания и прозрачности в современных условиях "),
                        _createElementVNode("li", null, " Рост оперативности реагирования ремонтных служб на обращения "),
                        _createElementVNode("li", null, "Сокращение перерывов в подаче ресурсов")
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_Icon, {
                        class: "app__card-icon",
                        name: "admin"
                      }),
                      _cache[89] || (_cache[89] = _createElementVNode("div", { class: "app__card-subheader" }, "Муниципалитеты", -1)),
                      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "app__card-header" }, "Органы власти", -1)),
                      _cache[91] || (_cache[91] = _createElementVNode("ul", { class: "app__card-list" }, [
                        _createElementVNode("li", null, " Повышение эффективности работы систем тепло- и водоснабжения "),
                        _createElementVNode("li", null, " Получение обратной связи для взаимодействия с потребителями "),
                        _createElementVNode("li", null, " Оптимизация формирования ремонтных и инвестиционных программ ")
                      ], -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_62, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => _cache[93] || (_cache[93] = [
                  _createElementVNode("div", { class: "app__color app__color--2" }, [
                    _createElementVNode("div", { class: "app__color-wrapper-outer visible--block--widest" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--6" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Достоверные данные для стратегического"),
                              _createElementVNode("br"),
                              _createTextVNode("управления и мониторинга ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--7" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Повышение эффективности технологического"),
                              _createElementVNode("br"),
                              _createTextVNode("оборудования и сокращение потерь поставляемого ресурса ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--8" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" Увеличение положительных отзывов и снижение негативных"),
                              _createElementVNode("br"),
                              _createTextVNode("настроений Населения по услугам ресурсоснабжения ")
                            ])
                          ]),
                          _createElementVNode("div", { class: "app__color-block app__color-block--9" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Прозрачность"),
                              _createElementVNode("br"),
                              _createTextVNode("при оказании услуг")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__color-wrapper-outer hidden--block--widest" }, [
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--6" }, [
                            _createElementVNode("div", { class: "hidden--flex--narrow" }, [
                              _createTextVNode(" Достоверные данные для"),
                              _createElementVNode("br"),
                              _createTextVNode("стратегического управления и мониторинга ")
                            ]),
                            _createElementVNode("div", { class: "visible--flex--narrow" }, [
                              _createTextVNode(" Достоверные данные"),
                              _createElementVNode("br"),
                              _createTextVNode("для стратегического"),
                              _createElementVNode("br"),
                              _createTextVNode("управления и мониторинга ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--7" }, [
                            _createElementVNode("div", { class: "hidden--flex--narrow" }, [
                              _createTextVNode(" Повышение эффективности технологического"),
                              _createElementVNode("br"),
                              _createTextVNode("оборудования и сокращение потерь поставляемого ресурса ")
                            ]),
                            _createElementVNode("div", { class: "visible--flex--narrow" }, [
                              _createTextVNode(" Повышение эффективности"),
                              _createElementVNode("br"),
                              _createTextVNode("технологического оборудования"),
                              _createElementVNode("br"),
                              _createTextVNode(" и сокращение потерь"),
                              _createElementVNode("br"),
                              _createTextVNode("поставляемого ресурса ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--8" }, [
                            _createElementVNode("div", { class: "hidden--flex--narrow" }, [
                              _createTextVNode(" Увеличение положительных отзывов и снижение негативных"),
                              _createElementVNode("br"),
                              _createTextVNode("настроений Населения по услугам ресурсоснабжения ")
                            ]),
                            _createElementVNode("div", { class: "visible--flex--narrow" }, [
                              _createTextVNode(" Увеличение положительных"),
                              _createElementVNode("br"),
                              _createTextVNode("отзывов и снижение негативных"),
                              _createElementVNode("br"),
                              _createTextVNode("настроений Населения по"),
                              _createElementVNode("br"),
                              _createTextVNode("услугам ресурсоснабжения ")
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__color-wrapper" }, [
                        _createElementVNode("div", { class: "app__color-wrapper-inner" }, [
                          _createElementVNode("div", { class: "app__color-block app__color-block--9" }, [
                            _createElementVNode("div", null, [
                              _createTextVNode("Прозрачность"),
                              _createElementVNode("br"),
                              _createTextVNode("при оказании услуг")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_63, [
              _createElementVNode("div", {
                class: _normalizeClass(["app__map", {
              'app__map--dark': _ctx.theme !== _ctx.Themes.default,
            }])
              }, null, 2),
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_Wrapper, null, {
                  default: _withCtx(() => _cache[94] || (_cache[94] = [
                    _createElementVNode("div", { class: "app__title" }, "Внедрения", -1),
                    _createElementVNode("div", { class: "app__subtitle" }, " Платформа успешно работает в 8 городах ", -1),
                    _createElementVNode("div", { class: "visible--block--desktops" }, [
                      _createElementVNode("div", { class: "app__grid" }, [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--1" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Краснодар"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--2" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Воронеж"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--3" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Липецк"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--4" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Белгород"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--5" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Обнинск"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ])
                      ]),
                      _createElementVNode("div", { class: "app__grid" }, [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--6" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Курчатов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--7" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Глазов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--8" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Заречный"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--9" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Ваш город"),
                          _createElementVNode("div", { class: "app__card-subheader" }, "Скоро")
                        ])
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "visible--block--middle" }, [
                      _createElementVNode("div", { class: "app__grid" }, [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--1" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Краснодар"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--2" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Воронеж"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--3" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Липецк"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--4" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Белгород"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--5" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Обнинск"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--6" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Курчатов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--7" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Глазов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--8" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Заречный"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения ")
                        ]),
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--9" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Ваш город"),
                          _createElementVNode("div", { class: "app__card-subheader" }, "Скоро")
                        ])
                      ])
                    ], -1)
                  ])),
                  _: 1
                }),
                (_openBlock(), _createBlock(_component_Carousel, _mergeProps({ class: "app__mobile-slider1 visible--block--narrow" }, _ctx.citiesCarouselconfig, { key: _ctx.slider }), {
                  addons: _withCtx(() => [
                    _createVNode(_component_Navigation, null, {
                      prev: _withCtx(() => _cache[104] || (_cache[104] = [])),
                      next: _withCtx(() => _cache[105] || (_cache[105] = [])),
                      _: 1
                    }),
                    _createVNode(_component_Pagination)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[95] || (_cache[95] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--1" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Краснодар"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[96] || (_cache[96] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--2" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Воронеж"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[97] || (_cache[97] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--3" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Липецк"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[98] || (_cache[98] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--4" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Белгород"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения с полевым уровнем ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[99] || (_cache[99] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--5" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Обнинск"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[100] || (_cache[100] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--6" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Курчатов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация теплоснабжения с полевым уровнем ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[101] || (_cache[101] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--7" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Глазов"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация тепло- и водоснабжения с полевым уровнем ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[102] || (_cache[102] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--8" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Заречный"),
                          _createElementVNode("div", { class: "app__card-subheader" }, " Цифровизация водоснабжения ")
                        ], -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_Slide, null, {
                      default: _withCtx(() => _cache[103] || (_cache[103] = [
                        _createElementVNode("div", { class: "app__card5" }, [
                          _createElementVNode("div", { class: "app__card-logo app__card-logo--9" }, [
                            _createElementVNode("div")
                          ]),
                          _createElementVNode("div", { class: "app__card5-header3" }, "Ваш город"),
                          _createElementVNode("div", { class: "app__card-subheader" }, "Скоро")
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16))
              ])
            ]),
            _createElementVNode("section", _hoisted_65, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => _cache[106] || (_cache[106] = [
                  _createElementVNode("div", { class: "app__title" }, " Индивидуальный подход к каждому заказчику ", -1),
                  _createElementVNode("div", { class: "app__grid" }, [
                    _createElementVNode("div", { class: "app__card4 app__card4--blue" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Поставка лицензии ПО"),
                      _createElementVNode("div", { class: "app__card-text" }, " Простая неисключительная лицензия по условиям заключенного лицензионного договора ")
                    ]),
                    _createElementVNode("div", { class: "app__card4 app__card4--orange" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Внедрение ПО"),
                      _createElementVNode("div", { class: "app__card-text" }, " Платформа в полном объёме или ее отдельные модули ")
                    ]),
                    _createElementVNode("div", { class: "app__card4 app__card4--red" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Комплексное внедрение"),
                      _createElementVNode("div", { class: "app__card-text" }, " Обследование технологических объектов с дальнейшими работами по проектированию поставкой оборудования его СМР и ПНР включая внедрение ПО ")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_66, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_67, [
                    _cache[108] || (_cache[108] = _createElementVNode("div", { class: "app__title" }, "Техническая поддержка", -1)),
                    _cache[109] || (_cache[109] = _createElementVNode("div", { class: "app__subtitle" }, " Не бросаем заказчика после внедрения ", -1)),
                    _createVNode(_component_ButtonAction, {
                      class: "app__section-header-link",
                      color: "rocky",
                      icon: "file",
                      link: `./Terms_of_Support.pdf`
                    }, {
                      default: _withCtx(() => _cache[107] || (_cache[107] = [
                        _createTextVNode("Полный список предоставляемых  "),
                        _createElementVNode("span", { class: "hidden--inline--narrow" }, "услуг", -1),
                        _createElementVNode("span", { class: "visible--inline--narrow" }, "...", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _cache[110] || (_cache[110] = _createElementVNode("div", { class: "app__grid" }, [
                    _createElementVNode("div", { class: "app__card6 app__card6--blue" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Общая"),
                      _createElementVNode("div", { class: "app__card-block app__card-block--1" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Кому предоставляется"),
                        _createElementVNode("div", { class: "app__card-text" }, " Потенциальные и коммерческие пользователи ПО ")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--2 app__card-block--4" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Стоимость"),
                        _createElementVNode("div", { class: "app__card-text" }, "Бесплатно")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--3" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Срок решения"),
                        _createElementVNode("div", { class: "app__card-text" }, "До 48 часов")
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__card6 app__card6--orange" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Базовая"),
                      _createElementVNode("div", { class: "app__card-block app__card-block--1" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Кому предоставляется"),
                        _createElementVNode("div", { class: "app__card-text" }, "Коммерческие пользователи ПО")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--2 app__card-block--5" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Стоимость"),
                        _createElementVNode("div", { class: "app__card-text" }, " В рамках подписки на обновление ПО действующих лицензий, 20% от общей стоимости лицензии ")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--3" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Срок решения"),
                        _createElementVNode("div", { class: "app__card-text" }, "До 32 часов")
                      ])
                    ]),
                    _createElementVNode("div", { class: "app__card6 app__card6--red" }, [
                      _createElementVNode("div", { class: "app__card-header" }, "Расширенная"),
                      _createElementVNode("div", { class: "app__card-block app__card-block--1" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Кому предоставляется"),
                        _createElementVNode("div", { class: "app__card-text" }, "Коммерческие пользователи ПО")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--2 app__card-block--5" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Стоимость"),
                        _createElementVNode("div", { class: "app__card-text" }, " В рамках отдельно заключенного рамочного договора ")
                      ]),
                      _createElementVNode("div", { class: "app__card-line" }),
                      _createElementVNode("div", { class: "app__card-block app__card-block--3" }, [
                        _createElementVNode("div", { class: "app__card-subheader" }, "Срок решения"),
                        _createElementVNode("div", { class: "app__card-text" }, " В соответствии с заключённым договором ")
                      ])
                    ])
                  ], -1))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("section", _hoisted_68, [
              _createVNode(_component_Wrapper, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", null, [
                      _cache[113] || (_cache[113] = _createElementVNode("div", { class: "app__title" }, "Новости и обновления", -1)),
                      _createElementVNode("ul", _hoisted_70, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsNow, (news, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `news--${index}`,
                            class: "app__news"
                          }, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, _toDisplayString(news.date), 1),
                              _createElementVNode("div", _hoisted_73, _toDisplayString(news.version), 1)
                            ]),
                            _createElementVNode("div", _hoisted_74, _toDisplayString(news.text), 1),
                            _cache[111] || (_cache[111] = _createElementVNode("div", { class: "app__news-line" }, null, -1))
                          ]))
                        }), 128))
                      ]),
                      (_ctx.newsNow.length < _ctx.NEWS.length)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            size: "helike",
                            skin: "secondary",
                            "is-wide": "",
                            onClick: _withModifiers(_ctx.more, ["prevent"])
                          }, {
                            default: _withCtx(() => _cache[112] || (_cache[112] = [
                              _createTextVNode("Показать ещё")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[118] || (_cache[118] = _createElementVNode("div", null, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[117] || (_cache[117] = _createElementVNode("div", { class: "app__title2" }, "Материалы о продукте", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material",
                          color: "rocky",
                          link: `./SITE_Digital_Resource_Supply.pdf`
                        }, {
                          default: _withCtx(() => _cache[114] || (_cache[114] = [
                            _createTextVNode("Презентация о продукте")
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material",
                          color: "rocky",
                          link: `./Platform_Brief.pdf`
                        }, {
                          default: _withCtx(() => _cache[115] || (_cache[115] = [
                            _createTextVNode("Краткое описание")
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material app__material--last",
                          color: "rocky",
                          link: `./DRSO_Approved_Licensing_Policy.pdf`
                        }, {
                          default: _withCtx(() => _cache[116] || (_cache[116] = [
                            _createTextVNode("Политика лицензирования")
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", null, [
                      _cache[122] || (_cache[122] = _createElementVNode("div", { class: "app__title2" }, "Материалы о продукте", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material",
                          color: "rocky",
                          link: `./SITE_Digital_Resource_Supply.pdf`
                        }, {
                          default: _withCtx(() => _cache[119] || (_cache[119] = [
                            _createTextVNode("Презентация о продукте")
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material",
                          color: "rocky",
                          link: `./Platform_Brief.pdf`
                        }, {
                          default: _withCtx(() => _cache[120] || (_cache[120] = [
                            _createTextVNode("Краткое описание")
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ButtonAction, {
                          class: "app__material app__material--last",
                          color: "rocky",
                          link: `./DRSO_Approved_Licensing_Policy.pdf`
                        }, {
                          default: _withCtx(() => _cache[121] || (_cache[121] = [
                            _createTextVNode("Политика лицензирования")
                          ])),
                          _: 1
                        })
                      ])
                    ]),
                    _cache[126] || (_cache[126] = _createElementVNode("div", null, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[125] || (_cache[125] = _createElementVNode("div", { class: "app__title2" }, "Новости и обновления", -1)),
                      _createElementVNode("ul", _hoisted_76, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsNow, (news, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `news--${index}`,
                            class: "app__news"
                          }, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, _toDisplayString(news.date), 1),
                              _createElementVNode("div", _hoisted_79, _toDisplayString(news.version), 1)
                            ]),
                            _createElementVNode("div", _hoisted_80, _toDisplayString(news.text), 1),
                            _cache[123] || (_cache[123] = _createElementVNode("div", { class: "app__news-line" }, null, -1))
                          ]))
                        }), 128))
                      ]),
                      (_ctx.newsNow.length < _ctx.NEWS.length)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            size: "helike",
                            skin: "secondary",
                            "is-wide": "",
                            onClick: _withModifiers(_ctx.more, ["prevent"])
                          }, {
                            default: _withCtx(() => _cache[124] || (_cache[124] = [
                              _createTextVNode("Показать ещё")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      (_ctx.isPlank)
        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _cache[132] || (_cache[132] = _createTextVNode(" Нажмите «Принять», если вы соглашаетесь с условиями обработки файлов cookie, нужных нам для аналитики на условиях, предусмотренных ")),
                _createVNode(_component_Link, {
                  text: "Политикой в отношении обработки персональных данных",
                  link: `./Personal_Data_Processing_Policy.pdf`
                }),
                _cache[133] || (_cache[133] = _createTextVNode(". Запретить обработку cookie вы можете через браузер. "))
              ]),
              _createVNode(_component_Button, {
                class: "app__plank-button",
                size: "helike",
                skin: "secondary",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.asseptPlank()), ["prevent"]))
              }, {
                default: _withCtx(() => _cache[134] || (_cache[134] = [
                  _createTextVNode("Принять")
                ])),
                _: 1
              }),
              _createVNode(_component_ButtonSimple, {
                skin: "transparent",
                size: "larishae",
                onClick: _withModifiers(_ctx.closePlank, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "close_20" })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _cache[135] || (_cache[135] = _createTextVNode(" Нажмите «Принять», если вы соглашаетесь с условиями обработки файлов cookie, нужных нам для аналитики на условиях, предусмотренных ")),
                _createVNode(_component_Link, {
                  text: "Политикой в отношении обработки персональных данных",
                  link: `./Personal_Data_Processing_Policy.pdf`
                }),
                _cache[136] || (_cache[136] = _createTextVNode(". Запретить обработку cookie вы можете через браузер. "))
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_component_Button, {
                  class: "app__plank-button",
                  size: "helike",
                  skin: "secondary",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.asseptPlank()), ["prevent"]))
                }, {
                  default: _withCtx(() => _cache[137] || (_cache[137] = [
                    _createTextVNode("Принять")
                  ])),
                  _: 1
                }),
                _createVNode(_component_ButtonSimple, {
                  skin: "transparent",
                  size: "larishae",
                  onClick: _withModifiers(_ctx.closePlank, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "close_20" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}